import { render } from "./Main.vue?vue&type=template&id=96b33078"
import script from "./Main.vue?vue&type=script&lang=ts"
export * from "./Main.vue?vue&type=script&lang=ts"

import "./Main.vue?vue&type=style&index=0&id=96b33078&scope=true&lang=css"
script.render = render

export default script